var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24C24 22.3425 19.299 21 13.5 21M24 24C24 25.6575 19.299 27 13.5 27C7.701 27 3 25.6575 3 24M24 24V31.4055C24 33.114 19.299 34.5 13.5 34.5C7.701 34.5 3 33.1155 3 31.4055V24M24 24C29.736 24 34.5 22.5195 34.5 21V6M13.5 21C7.701 21 3 22.3425 3 24M13.5 21C6.873 21 1.5 19.5195 1.5 18V10.5M13.5 7.5C6.873 7.5 1.5 8.8425 1.5 10.5M1.5 10.5C1.5 12.1575 6.873 13.5 13.5 13.5C13.5 15.0195 18.3795 16.5 24.1155 16.5C29.85 16.5 34.5 15.0195 34.5 13.5M34.5 6C34.5 4.3425 29.85 3 24.1155 3C18.3795 3 13.731 4.3425 13.731 6M34.5 6C34.5 7.6575 29.85 9 24.1155 9C18.381 9 13.731 7.6575 13.731 6M13.731 6V21.249",
    stroke: "#65C953",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.5d2be552715d063e17ed92746e8415e9.svg";
export { ForwardRef as ReactComponent };